import { NgModule } from '@angular/core';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { MyTeamPageComponent } from './pages';
import { TeamMemberCardComponent } from './components/team-member-card/team-member-card.component';
import { UiGeneralModule } from '../ui-general/ui-general.module';
import { BrowserModule } from '@angular/platform-browser';

@NgModule({
    declarations: [
        MyTeamPageComponent,
        TeamMemberCardComponent
    ],
    imports: [
        AngularFontAwesomeModule,
        UiGeneralModule,
        BrowserModule
    ], exports: [
        MyTeamPageComponent
    ]
  })
  export class TeamModule { }



// WEBPACK FOOTER //
// ./src/app/team/team.module.ts